import { render } from "./VueTree.vue?vue&type=template&id=2ecceca7&scoped=true"
import script from "./VueTree.vue?vue&type=script&lang=js"
export * from "./VueTree.vue?vue&type=script&lang=js"

import "./VueTree.vue?vue&type=style&index=0&id=2ecceca7&lang=less"
import "./VueTree.vue?vue&type=style&index=1&id=2ecceca7&lang=less&scoped=true"

import exportComponent from "/Users/ssthouse/Workspace/tree-chart/packages/vue3-tree-chart/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecceca7"]])

export default __exports__